import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

import authReducer from "./reducers/authSlice";
import profile from "./reducers/profile";
import workplace from "./reducers/workplace";
import backdrop from "./reducers/backdrop";


const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "profile", "workplace"], // We only want to persist the auth slice
};

const rootReducer = combineReducers({
  auth: authReducer,
  profile: profile,
  workplace: workplace,
  backdrop: backdrop
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

export const persistor = persistStore(store);